// Pathify
import { make } from 'vuex-pathify'
// import axios from 'axios'
const roles = localStorage.getItem('roles')
const routeTree = [
  {
    title: '数据统计',
    icon: 'mdi-view-dashboard',
    to: '/',
    role: ['root', 'dispatcher', 'sem', 'sale'],
  },
  {
    title: '个人中心',
    icon: 'mdi-account',
    to: '/components/profile/',
    role: ['root', 'dispatcher', 'sale'],
  },
  {
    title: '客户管理',
    icon: 'mdi-account-group',
    to: '/system/customer/',
    role: ['root', 'dispatcher'],
  },
  {
    title: '大搜数据',
    icon: 'mdi-arrow-collapse-up',
    to: '/marketing/',
    role: ['root', 'dispatcher'],
  },
  {
    title: '统计报表',
    icon: 'mdi-arrow-top-right',
    to: '/report/',
    role: ['root', 'dispatcher', 'sem'],
  },
  {
    title: '用户管理',
    icon: 'mdi-account-multiple-outline',
    to: '/system/admins/',
    role: ['root'],
  },
  {
    title: '角色管理',
    icon: 'mdi-account-key',
    to: '/system/roles/',
    role: ['root'],
  },
  /* {
    title: '分类管理',
    icon: 'mdi-arrange-send-backward',
    to: '/system/classify/',
    role: ['root', 'dispatcher'],
  },
  {
    title: 'Icons',
    icon: 'mdi-chart-bubble',
    to: '/components/icons/',
    role: ['root'],
  }, */
]
const routeTreeNew = []

let n = 0
routeTree.map((item, i, arr) => {
  if (item.role.includes(roles)) {
    routeTreeNew[n] = item
    n++
  }
})

const state = {
  drawer: null,
  drawerImage: true,
  mini: false,
  items: routeTreeNew,
}

const mutations = make.mutations(state)
const actions = {
  ...make.actions(state),
  init: async ({ dispatch }) => {
    // console.log(mutations)
    //
  },
}

const getters = {}

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters,
}
